<script lang="ts" context="module">
  import { getAppConfig } from '../../../../common/config/app-config';
  import {
    getContextedUrl,
    getJoodExpiredMembershipType,
    getJoodMembershipType,
    getStr,
    globalCurrencyTag,
    slideOpenAnimation,
  } from '../../../../common/util';
  import Icon from '../../../common/components/Icon.svelte';
  import JoodExpire from '../../../common/components/productTile/components/JoodExpire.svelte';
  import { getJoodCardImageUrlNew } from '../../services/pdp-data-services';

  const membershipType = getJoodMembershipType();
  const expiredMembershipType = getJoodExpiredMembershipType();
  const { lang } = getAppConfig();
</script>

<script lang="ts">
  export let vasEntry;
  export let joodType;
  export let linkType;
  export let isRevealState;
  export let typeClass;
  export let pageClass = '';
  let open = false;
  const { joodUserTypeMap } = getAppConfig();
  const mapServicePrice = joodType ? joodUserTypeMap[`${joodType}PRIMESERVICE`] : joodUserTypeMap['NOPRIMESERVICE'];
  $: joodTypeClass = `jood-${joodType.toLowerCase()}`;
  $: revealGoldFlexClass = isRevealState ? 'jood-reveal jood-closed' : 'jood-open';
  $: joodRevealClass = isRevealState ? 'js-jood-reveal-container jood-hide jood-reveal-div' : '';
  $: buttonLabel =
    linkType === 'upgrade' ? 'extra.jood.upgrade.to.gold.btn.text' : 'extra.jood.plus.subscribe.to.gold.button.now';
  const joodCardImageUrl = getJoodCardImageUrlNew(getJoodMembershipType());
</script>

<div class="c_joodcart c_joodvas col-12 {pageClass}">
  <div
    class="c_jood-card jood-product-card jood-list-view {typeClass} {joodTypeClass} {revealGoldFlexClass} jood-cart-lang-{lang} {expiredMembershipType ===
    'BASICPRIME'
      ? 'expire-service-container'
      : ''}"
  >
    {#if isRevealState}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="reveal-gold-text js-jood-reveal-gold-vas accordion-header" on:click={() => (open = !open)}>
        {#if expiredMembershipType === 'BASICPRIME'}
          <div class="act-expire-title-container">
            {getStr('extra.jood.pdp.getoff.blue.text')}
          </div>
        {:else if expiredMembershipType === 'SMARTPRIME'}
          <span class="jood-reveal-label">
            {getStr('extra.pdp.prime.jood.smart.revelprice.text')}
          </span>
        {:else}
          <span class="jood-reveal-label js-jood-reveal-btn">
            {getStr('extra.pdp.prime.jood.gold.revelprice.text')}
          </span>
          <span class="jood-reveal-label js-jood-reveal-hide-btn jood-hide">
            {getStr('extra.jood.hide.gold.price.text')}
          </span>
        {/if}
        <!-- <span class="c_icon_new c_icon_new--chevron_down jood-arrow jood-arrow-reveal jood-arrow-down"></span> -->
        <span class:rotate180={open}>
          <Icon type="font" glyph="chevron_down" mobileSize={14} desktopSize={14} />
        </span>
      </div>
    {/if}
    {#if open}
      <div class={joodRevealClass} transition:slideOpenAnimation>
        {#if (membershipType === 'NOPRIME' || membershipType === 'BASICPRIME') && !expiredMembershipType}
          <div class="c_jood-offer-message">
            <span class="">{getStr('extra.jood.pdp.getoff.gold.text')}</span>
            <a href={getStr('/jood/benefits')}>
              {getStr('extra.pdp.jood.tile.subscribetojoobtext')}
            </a>
          </div>
        {/if}
        <div class="c_joodvas-service-container js-cart-vas-scroller-container">
          {#each vasEntry.vasPrices as vasPrice}
            {#if vasEntry.combinedVas}
              {#if vasPrice.additionalAwsProductCode === null && vasPrice.additionalAwsVasGroup === null}
                {#if !!vasPrice?.[mapServicePrice]?.formattedValue && vasPrice?.[mapServicePrice]?.formattedValue !== null && vasPrice?.[mapServicePrice]?.formattedValue?.length > 0}
                  <div class="c_joodvas-service-wrapper js-cart-vas-scroller-content">
                    <div class="c_joodvas-title">
                      {vasPrice.vasType.label}
                    </div>
                    <div class="c_joodvas-gold-container">
                      <div class="c_joodvas-gold-price-wrapper">
                        <div class="c_joodvas-gold-price">
                          {@html globalCurrencyTag}
                          <span class="fw-bold">
                            {+vasPrice.servicePrice?.formattedValue - +vasPrice?.[mapServicePrice]?.formattedValue}
                          </span>
                          <img src={joodCardImageUrl} alt="Jood Card" />
                        </div>
                        {#if parseInt(vasPrice.servicePrice.formattedValue) > 0}
                          <div class="c_joodvas-old-price-details">
                            <span class="striked-off">{vasPrice.servicePrice.formattedValue}</span>
                            <strong class="orange-text">
                              {@html getStr('extra.cart.saved.amt', [
                                globalCurrencyTag,
                                parseInt(vasPrice[mapServicePrice].formattedValue),
                              ])}
                            </strong>
                          </div>
                        {/if}
                      </div>
                    </div>
                  </div>
                {/if}
              {/if}
            {:else if !!vasPrice?.[mapServicePrice]?.formattedValue && vasPrice?.[mapServicePrice]?.formattedValue !== null && vasPrice?.[mapServicePrice]?.formattedValue?.length > 0}
              <div class="c_joodvas-service-wrapper js-cart-vas-scroller-content">
                <div class="c_joodvas-title">
                  {vasPrice.vasType.label}
                </div>
                <div class="c_joodvas-gold-container">
                  <div class="c_joodvas-gold-price-wrapper">
                    <div class="c_joodvas-gold-price">
                      {@html globalCurrencyTag}
                      <span class="fw-bold">
                        {+vasPrice.servicePrice?.formattedValue - +vasPrice?.[mapServicePrice]?.formattedValue}
                      </span>
                      <img src={joodCardImageUrl} alt="Jood Card" />
                    </div>
                    {#if parseInt(vasPrice.servicePrice.formattedValue) > 0}
                      <div class="c_joodvas-old-price-details">
                        <span class="striked-off">{vasPrice.servicePrice.formattedValue}</span>
                        <strong class="orange-text">
                          {@html getStr('extra.cart.saved.amt', [
                            globalCurrencyTag,
                            parseInt(vasPrice?.[mapServicePrice].formattedValue),
                          ])}
                        </strong>
                      </div>
                    {/if}
                  </div>
                </div>
              </div>
            {/if}
          {/each}
        </div>
        {#if !expiredMembershipType}
          <div class="c_joodvas-button-container">
            <a href={getContextedUrl('/jood/benefits')} class="jood-subscribe-btn">
              {getStr(buttonLabel)}
            </a>
          </div>
        {/if}
        {#if expiredMembershipType === 'BASICPRIME' || expiredMembershipType === 'SMARTPRIME'}
          <JoodExpire accordion={true} />
        {/if}
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';
  .act-expire-title-container {
    color: $functional-orange;
    font-size: 16px;
    font-weight: 700;
    line-height: 18px;
  }
  .c_joodvas-gold-price {
    img {
      width: 24px;
      border-radius: 2px;
    }
  }
  .jood-reveal-div {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }
  .rotate180 {
    transform: rotate(180deg);
    transition: transform 0.25s ease;
  }
</style>
